
export const SP1000 = 'SP1000'

export const SP2000 = 'SP2000'

export const SP2100 = 'SP2100'
export const SP21001 = 'SP21001'
export const SP21002 = 'SP21002'
export const SP21003 = 'SP21003'
export const SP21004 = 'SP21004'
export const SP21005 = 'SP21005'

export const SP2200 = 'SP2200'
export const SP22001 = 'SP22001'
export const SP22002 = 'SP22002'
export const SP22003 = 'SP22003'
export const SP22004 = 'SP22004'
export const SP22005 = 'SP22005'
export const SP22006 = 'SP22006'
export const SP22007 = 'SP22007'
export const SP3000 = 'SP3000'

export const SP3100 = 'SP3100'
export const SP31001 = 'SP31001'
export const SP31002 = 'SP31002'
export const SP31003 = 'SP31003'
export const SP31004 = 'SP31004'
export const SP31005 = 'SP31005'
export const SP31006 = 'SP31006'
export const SP31007 = 'SP31007'
export const SP31008 = 'SP31008'

export const SP3200 = 'SP3200'
export const SP32001 = 'SP32001'
export const SP32002 = 'SP32002'
export const SP32003 = 'SP32003'
export const SP32004 = 'SP32004'
export const SP32005 = 'SP32005'
export const SP32006 = 'SP32006'
export const SP32007 = 'SP32007'
export const SP32008 = 'SP32008'
export const SP32009 = 'SP32009'

export const SP3300 = 'SP3300'
export const SP33001 = 'SP33001'
export const SP33002 = 'SP33002'
export const SP33003 = 'SP33003'
export const SP33004 = 'SP33004'
export const SP33005 = 'SP33005'
export const SP33006 = 'SP33006'
export const SP33007 = 'SP33007'
export const SP33008 = 'SP33008'

export const SP4000 = 'SP4000'

export const SP4000_yy = 'SP4000_yy'
export const SP4000_yy_1 = 'SP4000_yy_1'
export const SP4000_yy_2 = 'SP4000_yy_2'
export const SP4000_yy_3 = 'SP4000_yy_3'
export const SP4000_yy_4 = 'SP4000_yy_4'
export const SP4000_yy_7 = 'SP4000_yy_7'
export const SP4000_yy_8 = 'SP4000_yy_8'
export const SP4000_yy_9 = 'SP4000_yy_9'
export const SP4000_yy_10 = 'SP4000_yy_10'
export const SP4000_yy_11 = 'SP4000_yy_11'
export const SP4000_yy_12 = 'SP4000_yy_12'
export const SP4000_yy_13 = 'SP4000_yy_13'
export const SP4000_yy_14 = 'SP4000_yy_14'
export const SP4000_yy_15 = 'SP4000_yy_15'
export const SP4000_yy_21 = 'SP4000_yy_21'
export const SP4000_yy_22 = 'SP4000_yy_22'
export const SP4000_yy_23 = 'SP4000_yy_23'

export const SP4000_ms = 'SP4000_ms'
export const SP4000_ms_1 = 'SP4000_ms_1'
export const SP4000_ms_2 = 'SP4000_ms_2'
export const SP4000_ms_3 = 'SP4000_ms_3'
export const SP4000_ms_4 = 'SP4000_ms_4'
export const SP4000_ms_7 = 'SP4000_ms_7'
export const SP4000_ms_8 = 'SP4000_ms_8'
export const SP4000_ms_9 = 'SP4000_ms_9'
export const SP4000_ms_10 = 'SP4000_ms_10'
export const SP4000_ms_11 = 'SP4000_ms_11'
export const SP4000_ms_12 = 'SP4000_ms_12'
export const SP4000_ms_13 = 'SP4000_ms_13'
export const SP4000_ms_14 = 'SP4000_ms_14'
export const SP4000_ms_15 = 'SP4000_ms_15'

export const SP4000_ms_21 = 'SP4000_ms_21'
export const SP4000_ms_22 = 'SP4000_ms_22'
export const SP4000_ms_23 = 'SP4000_ms_23'

// export const SP4000_yy_7 = 'SP4000_yy_7'
// export const SP4000_yy_8 = 'SP4000_yy_8'
// export const SP4000_yy_9 = 'SP4000_yy_9'
// export const SP4000_yy_10 = 'SP4000_yy_10'
// export const SP4000_yy_11 = 'SP4000_yy_11'
// export const SP4000_yy_12 = 'SP4000_yy_12'
// export const SP4000_yy_13 = 'SP4000_yy_13'

export const SP4400_yy_1 = 'SP4400_yy_1'
export const SP4400_yy_2 = 'SP4400_yy_2'
export const SP4400_yy_3 = 'SP4400_yy_3'
export const SP4400_yy_4 = 'SP4400_yy_4'
export const SP4400_yy_5 = 'SP4400_yy_5'
export const SP4400_ms_1 = 'SP4400_ms_1'
export const SP4400_ms_2 = 'SP4400_ms_2'
export const SP4400_ms_3 = 'SP4400_ms_3'
export const SP4400_ms_4 = 'SP4400_ms_4'
export const SP4400_ms_5 = 'SP4400_ms_5'

export const SP5000 = 'SP5000'

export const SP5100 = 'SP5100'
export const SP5100_yy = 'SP5100_yy'
export const SP5100_yy_1 = 'SP5100_yy_1'
export const SP5100_yy_2 = 'SP5100_yy_2'
export const SP5100_yy_3 = 'SP5100_yy_3'
export const SP5100_yy_4 = 'SP5100_yy_4'
export const SP5100_yy_5 = 'SP5100_yy_5'

export const SP5100_ms = 'SP5100_ms'
export const SP5100_ms_1 = 'SP5100_ms_1'
export const SP5100_ms_2 = 'SP5100_ms_2'
export const SP5100_ms_3 = 'SP5100_ms_3'
export const SP5100_ms_4 = 'SP5100_ms_4'
export const SP5100_ms_5 = 'SP5100_ms_5'

export const SP5200 = 'SP5200'
export const SP52001 = 'SP52001'
export const SP52002 = 'SP52002'

export const SP5300 = 'SP5300'
export const SP53001 = 'SP53001'
export const SP53002 = 'SP53002'
export const SP53003 = 'SP53003'
export const SP53004 = 'SP53004'

export const SP56002 = 'SP56002'
export const SP56003 = 'SP56003'
export const SP56004 = 'SP56004'
export const SP56005 = 'SP56005'

export const SP6000 = 'SP6000'
export const SP60001 = 'SP60001'
export const SP60002 = 'SP60002'
export const SP60003 = 'SP60003'
export const SP60004 = 'SP60004'
export const SP60005 = 'SP60005'
export const SP60006 = 'SP60006'

export const SP7000 = 'SP7000'

export const SP8000 = 'SP8000'

export const SP8100 = 'SP8100'
export const SP81001 = 'SP81001'
export const SP81002 = 'SP81002'
export const SP81003 = 'SP81003'
export const SP81004 = 'SP81004'

export const SP8200 = 'SP8200'
export const SP82001 = 'SP82001'
export const SP82002 = 'SP82002'
export const SP82003 = 'SP82003'
export const SP82004 = 'SP82004'

// export const SPRouter = [
// 	{
// 		title: '首页',
// 		path: '/workbench',
// 		itemType: 1,
// 		sort: 1,
// 		childPermission: [],
// 		permission: SP1000
// 	},
// 	{
// 		title: '组织管理',
// 		itemType: 1,
// 		sort: 2,
// 		permission: SP2000,
// 		childPermission: [
// 			{
// 				title: '学校管理',
// 				path: '/workbench/school_mgn',
// 				itemType: 2,
// 				sort: 1,
// 				permission: SP2100,
// 				childPermission: [
// 					{
// 						title: '新建',
// 						path: '',
// 						permission: SP21001,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '导入',
// 						path: '',
// 						permission: SP21002,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					},
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP21003,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					},
// 					{
// 						title: '删除',
// 						path: '',
// 						permission: SP21004,
// 						itemType: 99,
// 						sort: 4,
// 						childPermission: []
// 					}
// 				]
// 			},
// 			{
// 				title: '班级管理',
// 				path: '/workbench/classgrade_mgn',
// 				itemType: 2,
// 				sort: 2,
// 				permission: SP2200,
// 				childPermission: [
// 					{
// 						title: '新建',
// 						path: '',
// 						permission: SP22001,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '导入',
// 						path: '',
// 						permission: SP22002,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					},
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP22003,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					},
// 					{
// 						title: '删除',
// 						path: '',
// 						permission: SP22004,
// 						itemType: 99,
// 						sort: 4,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量删除',
// 						path: '',
// 						permission: SP22005,
// 						itemType: 99,
// 						sort: 5,
// 						childPermission: []
// 					},
// 					{
// 						title: '关联老师',
// 						path: '',
// 						permission: SP22006,
// 						itemType: 99,
// 						sort: 6,
// 						childPermission: []
// 					},
// 					{
// 						title: '加入班级',
// 						path: '',
// 						permission: SP22007,
// 						itemType: 99,
// 						sort: 7,
// 						childPermission: []
// 					}
// 				]
// 			}
// 		]
// 	},
// 	{
// 		title: '人员管理',
// 		itemType: 1,
// 		sort: 2,
// 		permission: SP3000,
// 		childPermission: [
// 			{
// 				title: '校管管理',
// 				path: '/workbench/school_admin_mgn',
// 				itemType: 2,
// 				sort: 1,
// 				permission: SP3100,
// 				childPermission: [
// 					{
// 						title: '新建',
// 						path: '',
// 						permission: SP31001,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '导入',
// 						path: '',
// 						permission: SP31002,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					},
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP31003,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量删除',
// 						path: '',
// 						permission: SP31004,
// 						itemType: 99,
// 						sort: 4,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量重置密码',
// 						path: '',
// 						permission: SP31005,
// 						itemType: 99,
// 						sort: 5,
// 						childPermission: []
// 					},
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP31006,
// 						itemType: 99,
// 						sort: 6,
// 						childPermission: []
// 					},
// 					{
// 						title: '删除',
// 						path: '',
// 						permission: SP31007,
// 						itemType: 99,
// 						sort: 7,
// 						childPermission: []
// 					},
// 					{
// 						title: '重置密码',
// 						path: '',
// 						permission: SP31008,
// 						itemType: 99,
// 						sort: 8,
// 						childPermission: []
// 					}
// 				]
// 			},
// 			{
// 				title: '教师管理',
// 				path: '/workbench/teacher_mgn',
// 				itemType: 2,
// 				sort: 2,
// 				permission: SP3200,
// 				childPermission: [
// 					{
// 						title: '新建',
// 						path: '',
// 						permission: SP32001,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '导入',
// 						path: '',
// 						permission: SP32002,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					},
// 					{
// 						title: '导出',
// 						path: '',
// 						permission: SP32003,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量删除',
// 						path: '',
// 						permission: SP32004,
// 						itemType: 99,
// 						sort: 4,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量重置密码',
// 						path: '',
// 						permission: SP32005,
// 						itemType: 99,
// 						sort: 5,
// 						childPermission: []
// 					},
// 					{
// 						title: '查看',
// 						path: '',
// 						permission: SP32006,
// 						itemType: 99,
// 						sort: 6,
// 						childPermission: []
// 					},
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP32007,
// 						itemType: 99,
// 						sort: 7,
// 						childPermission: []
// 					},
// 					{
// 						title: '账号状态',
// 						path: '',
// 						permission: SP32008,
// 						itemType: 99,
// 						sort: 8,
// 						childPermission: []
// 					}
// 				]
// 			},
// 			{
// 				title: '学生管理',
// 				path: '/workbench/student_mgn',
// 				itemType: 2,
// 				sort: 3,
// 				permission: SP3300,
// 				childPermission: [
// 					{
// 						title: '新建',
// 						path: '',
// 						permission: SP33001,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '导入',
// 						path: '',
// 						permission: SP33002,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					},
// 					{
// 						title: '导出',
// 						path: '',
// 						permission: SP33003,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量删除',
// 						path: '',
// 						permission: SP33004,
// 						itemType: 99,
// 						sort: 4,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量重置密码',
// 						path: '',
// 						permission: SP33005,
// 						itemType: 99,
// 						sort: 5,
// 						childPermission: []
// 					},
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP33006,
// 						itemType: 99,
// 						sort: 6,
// 						childPermission: []
// 					},
// 					{
// 						title: '删除',
// 						path: '',
// 						permission: SP33007,
// 						itemType: 99,
// 						sort: 7,
// 						childPermission: []
// 					},
// 					{
// 						title: '重置密码',
// 						path: '',
// 						permission: SP33008,
// 						itemType: 99,
// 						sort: 8,
// 						childPermission: []
// 					}
// 				]
// 			}
// 		]
// 	},
// 	{
// 		title: '资源管理',
// 		path: '/workbench/teachingManagement',
// 		itemType: 1,
// 		sort: 4,
// 		permission: SP4000,
// 		childPermission: [
// 			{
// 				title: '新建',
// 				path: '',
// 				permission: SP40001,
// 				itemType: 99,
// 				sort: 1,
// 				childPermission: []
// 			},
// 			{
// 				title: '导出',
// 				path: '',
// 				permission: SP40002,
// 				itemType: 99,
// 				sort: 2,
// 				childPermission: []
// 			},
// 			{
// 				title: '批量删除',
// 				path: '',
// 				permission: SP40003,
// 				itemType: 99,
// 				sort: 3,
// 				childPermission: []
// 			},
// 			{
// 				title: '查看',
// 				path: '',
// 				permission: SP40004,
// 				itemType: 99,
// 				sort: 4,
// 				childPermission: []
// 			},
// 			{
// 				title: '编辑',
// 				path: '',
// 				permission: SP40005,
// 				itemType: 99,
// 				sort: 5,
// 				childPermission: []
// 			},
// 			{
// 				title: '删除',
// 				path: '',
// 				permission: SP40006,
// 				itemType: 99,
// 				sort: 6,
// 				childPermission: []
// 			},
// 			{
// 				title: '上架',
// 				path: '',
// 				permission: SP40007,
// 				itemType: 99,
// 				sort: 7,
// 				childPermission: []
// 			}
// 		]
// 	},
// 	{
// 		title: '题库管理',
// 		path: '/workbench/abilityList',
// 		itemType: 1,
// 		sort: 5,
// 		permission: SP5000,
// 		childPermission: [
// 			{
// 				title: '题库列表',
// 				path: '/workbench/abilityList',
// 				itemType: 2,
// 				sort: 1,
// 				permission: SP5100,
// 				childPermission: [
// 					{
// 						title: '新建',
// 						path: '',
// 						permission: SP5100_yy_1,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量删除',
// 						path: '',
// 						permission: SP5100_yy_2,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					},
// 					{
// 						title: '查看',
// 						path: '',
// 						permission: SP5100_yy_3,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					},
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP5100_yy_4,
// 						itemType: 99,
// 						sort: 4,
// 						childPermission: []
// 					},
// 					{
// 						title: '删除',
// 						path: '',
// 						permission: SP5100_yy_5,
// 						itemType: 99,
// 						sort: 5,
// 						childPermission: []
// 					}
// 				]
// 			},
// 			{
// 				title: '能力点',
// 				path: '/workbench/powerPoint',
// 				itemType: 2,
// 				sort: 2,
// 				permission: SP5200,
// 				childPermission: [
// 					{
// 						title: '添加',
// 						path: '',
// 						permission: SP52001,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '删除',
// 						path: '',
// 						permission: SP52002,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					}
// 				]
// 			},
// 			{
// 				title: '知识点',
// 				path: '/workbench/knowPoint',
// 				itemType: 2,
// 				sort: 3,
// 				permission: SP5300,
// 				childPermission: [
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP53001,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '添加分类',
// 						path: '',
// 						permission: SP53002,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					},
// 					{
// 						title: '添加知识点',
// 						path: '',
// 						permission: SP53003,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					},
// 					{
// 						title: '删除',
// 						path: '',
// 						permission: SP53004,
// 						itemType: 99,
// 						sort: 4,
// 						childPermission: []
// 					}
// 				]
// 			}
// 		]
// 	},
// 	{
// 		title: '谱例管理',
// 		path: '/workbench/example_Manage',
// 		itemType: 1,
// 		sort: 6,
// 		permission: SP6000,
// 		childPermission: [
// 			{
// 				title: '新建',
// 				path: '',
// 				permission: SP60001,
// 				itemType: 99,
// 				sort: 1,
// 				childPermission: []
// 			},
// 			{
// 				title: '批量删除',
// 				path: '',
// 				permission: SP60002,
// 				itemType: 99,
// 				sort: 2,
// 				childPermission: []
// 			},
// 			{
// 				title: '谱音',
// 				path: '',
// 				permission: SP60003,
// 				itemType: 99,
// 				sort: 3,
// 				childPermission: []
// 			},
// 			{
// 				title: '谱例',
// 				path: '',
// 				permission: SP60004,
// 				itemType: 99,
// 				sort: 4,
// 				childPermission: []
// 			},
// 			{
// 				title: '查看',
// 				path: '',
// 				permission: SP60005,
// 				itemType: 99,
// 				sort: 5,
// 				childPermission: []
// 			}
// 		]
// 	},
// 	{
// 		title: '权益管理',
// 		path: '/workbench/exam_activity',
// 		itemType: 1,
// 		sort: 7,
// 		permission: SP7000,
// 		childPermission: []
// 	}
// 	// {
// 	// 	title: '权限管理',
// 	// 	path: '/workbench/public_notice',
// 	// 	itemType: 1,
// 	// 	sort: 8,
// 	// 	permission: SP8000,
// 	// 	childPermission: [
// 	// 		{
// 	// 			title: '新建',
// 	// 			path: '',
// 	// 			permission: SP80001,
// 	// 			itemType: 99,
// 	// 			sort: 1,
// 	// 			childPermission: []
// 	// 		},
// 	// 		{
// 	// 			title: '批量删除',
// 	// 			path: '',
// 	// 			permission: SP80002,
// 	// 			itemType: 99,
// 	// 			sort: 2,
// 	// 			childPermission: []
// 	// 		},
// 	// 		{
// 	// 			title: '编辑',
// 	// 			path: '',
// 	// 			permission: SP80003,
// 	// 			itemType: 99,
// 	// 			sort: 3,
// 	// 			childPermission: []
// 	// 		},
// 	// 		{
// 	// 			title: '删除',
// 	// 			path: '',
// 	// 			permission: SP80004,
// 	// 			itemType: 99,
// 	// 			sort: 4,
// 	// 			childPermission: []
// 	// 		}
// 	// 	]
// 	// }
// ]

// export const teachRouter = [
// 	{
// 		title: '组织管理',
// 		itemType: 1,
// 		sort: 2,
// 		permission: SP2000,
// 		childPermission: [
// 			{
// 				title: '班级管理',
// 				path: '/workbench/classgrade_mgn',
// 				itemType: 2,
// 				sort: 1,
// 				permission: SP2200,
// 				childPermission: [
// 					{
// 						title: '新建',
// 						path: '',
// 						permission: SP22001,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '导入',
// 						path: '',
// 						permission: SP22002,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					},
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP22003,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					},
// 					{
// 						title: '删除',
// 						path: '',
// 						permission: SP22004,
// 						itemType: 99,
// 						sort: 4,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量删除',
// 						path: '',
// 						permission: SP22005,
// 						itemType: 99,
// 						sort: 5,
// 						childPermission: []
// 					},
// 					{
// 						title: '加入班级',
// 						path: '',
// 						permission: SP22007,
// 						itemType: 99,
// 						sort: 7,
// 						childPermission: []
// 					}
// 				]
// 			}
// 		]
// 	},
// 	{
// 		title: '人员管理',
// 		itemType: 1,
// 		sort: 2,
// 		permission: SP3000,
// 		childPermission: [
// 			{
// 				title: '学生管理',
// 				path: '/workbench/student_mgn',
// 				itemType: 2,
// 				sort: 1,
// 				permission: SP3300,
// 				childPermission: [
// 					{
// 						title: '新建',
// 						path: '',
// 						permission: SP33001,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '导入',
// 						path: '',
// 						permission: SP33002,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					},
// 					{
// 						title: '导出',
// 						path: '',
// 						permission: SP33003,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量删除',
// 						path: '',
// 						permission: SP33004,
// 						itemType: 99,
// 						sort: 4,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量重置密码',
// 						path: '',
// 						permission: SP33005,
// 						itemType: 99,
// 						sort: 5,
// 						childPermission: []
// 					},
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP33006,
// 						itemType: 99,
// 						sort: 6,
// 						childPermission: []
// 					},
// 					{
// 						title: '删除',
// 						path: '',
// 						permission: SP33007,
// 						itemType: 99,
// 						sort: 7,
// 						childPermission: []
// 					},
// 					{
// 						title: '重置密码',
// 						path: '',
// 						permission: SP33008,
// 						itemType: 99,
// 						sort: 8,
// 						childPermission: []
// 					}
// 				]
// 			}
// 		]
// 	},
// 	{
// 		title: '资源管理',
// 		path: '/workbench/teachingManagement',
// 		itemType: 1,
// 		sort: 4,
// 		permission: SP4000,
// 		childPermission: [
// 			{
// 				title: '查看',
// 				path: '',
// 				permission: SP40004,
// 				itemType: 99,
// 				sort: 4,
// 				childPermission: []
// 			}
// 		]
// 	},
// 	{
// 		title: '题库管理',
// 		path: '/workbench/abilityList',
// 		itemType: 1,
// 		sort: 5,
// 		permission: SP5000,
// 		childPermission: [
// 			{
// 				title: '题库列表',
// 				path: '/workbench/abilityList',
// 				itemType: 2,
// 				sort: 1,
// 				permission: SP5100,
// 				childPermission: [
// 					{
// 						title: '新建',
// 						path: '',
// 						permission: SP5100_yy_1,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量删除',
// 						path: '',
// 						permission: SP5100_yy_2,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					},
// 					{
// 						title: '查看',
// 						path: '',
// 						permission: SP5100_yy_3,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					},
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP5100_yy_4,
// 						itemType: 99,
// 						sort: 4,
// 						childPermission: []
// 					},
// 					{
// 						title: '删除',
// 						path: '',
// 						permission: SP5100_yy_5,
// 						itemType: 99,
// 						sort: 5,
// 						childPermission: []
// 					}
// 				]
// 			},
// 			{
// 				title: '能力点',
// 				path: '/workbench/powerPoint',
// 				itemType: 2,
// 				sort: 2,
// 				permission: SP5200,
// 				childPermission: []
// 			},
// 			{
// 				title: '知识点',
// 				path: '/workbench/knowPoint',
// 				itemType: 2,
// 				sort: 3,
// 				permission: SP5300,
// 				childPermission: []
// 			}
// 		]
// 	},
// 	{
// 		title: '谱例管理',
// 		path: '/workbench/example_Manage',
// 		itemType: 1,
// 		sort: 6,
// 		permission: SP6000,
// 		childPermission: [
// 			{
// 				title: '新建',
// 				path: '',
// 				permission: SP60001,
// 				itemType: 99,
// 				sort: 1,
// 				childPermission: []
// 			},
// 			{
// 				title: '批量删除',
// 				path: '',
// 				permission: SP60002,
// 				itemType: 99,
// 				sort: 2,
// 				childPermission: []
// 			},
// 			{
// 				title: '谱音',
// 				path: '',
// 				permission: SP60003,
// 				itemType: 99,
// 				sort: 3,
// 				childPermission: []
// 			},
// 			{
// 				title: '谱例',
// 				path: '',
// 				permission: SP60004,
// 				itemType: 99,
// 				sort: 4,
// 				childPermission: []
// 			},
// 			{
// 				title: '查看',
// 				path: '',
// 				permission: SP60005,
// 				itemType: 99,
// 				sort: 5,
// 				childPermission: []
// 			}
// 		]
// 	},
// 	{
// 		title: '权益管理',
// 		path: '/workbench/exam_activity',
// 		itemType: 1,
// 		sort: 7,
// 		permission: SP7000,
// 		childPermission: []
// 	}
// ]

// export const schoolRouter = [
// 	{
// 		title: '组织管理',
// 		itemType: 1,
// 		sort: 2,
// 		permission: SP2000,
// 		childPermission: [
// 			{
// 				title: '班级管理',
// 				path: '/workbench/classgrade_mgn',
// 				itemType: 2,
// 				sort: 2,
// 				permission: SP2200,
// 				childPermission: [
// 					{
// 						title: '新建',
// 						path: '',
// 						permission: SP22001,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '导入',
// 						path: '',
// 						permission: SP22002,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					},
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP22003,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					},
// 					{
// 						title: '删除',
// 						path: '',
// 						permission: SP22004,
// 						itemType: 99,
// 						sort: 4,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量删除',
// 						path: '',
// 						permission: SP22005,
// 						itemType: 99,
// 						sort: 5,
// 						childPermission: []
// 					},
// 					{
// 						title: '关联老师',
// 						path: '',
// 						permission: SP22006,
// 						itemType: 99,
// 						sort: 6,
// 						childPermission: []
// 					}
// 				]
// 			}
// 		]
// 	},
// 	{
// 		title: '人员管理',
// 		itemType: 1,
// 		sort: 2,
// 		permission: SP3000,
// 		childPermission: [
// 			{
// 				title: '教师管理',
// 				path: '/workbench/teacher_mgn',
// 				itemType: 2,
// 				sort: 2,
// 				permission: SP3200,
// 				childPermission: [
// 					{
// 						title: '新建',
// 						path: '',
// 						permission: SP32001,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '导入',
// 						path: '',
// 						permission: SP32002,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					},
// 					{
// 						title: '导出',
// 						path: '',
// 						permission: SP32003,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量删除',
// 						path: '',
// 						permission: SP32004,
// 						itemType: 99,
// 						sort: 4,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量重置密码',
// 						path: '',
// 						permission: SP32005,
// 						itemType: 99,
// 						sort: 5,
// 						childPermission: []
// 					},
// 					{
// 						title: '查看',
// 						path: '',
// 						permission: SP32006,
// 						itemType: 99,
// 						sort: 6,
// 						childPermission: []
// 					},
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP32007,
// 						itemType: 99,
// 						sort: 7,
// 						childPermission: []
// 					},
// 					{
// 						title: '账号状态',
// 						path: '',
// 						permission: SP32008,
// 						itemType: 99,
// 						sort: 8,
// 						childPermission: []
// 					}
// 				]
// 			},
// 			{
// 				title: '学生管理',
// 				path: '/workbench/student_mgn',
// 				itemType: 2,
// 				sort: 3,
// 				permission: SP3300,
// 				childPermission: [
// 					{
// 						title: '新建',
// 						path: '',
// 						permission: SP33001,
// 						itemType: 99,
// 						sort: 1,
// 						childPermission: []
// 					},
// 					{
// 						title: '导入',
// 						path: '',
// 						permission: SP33002,
// 						itemType: 99,
// 						sort: 2,
// 						childPermission: []
// 					},
// 					{
// 						title: '导出',
// 						path: '',
// 						permission: SP33003,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量删除',
// 						path: '',
// 						permission: SP33004,
// 						itemType: 99,
// 						sort: 4,
// 						childPermission: []
// 					},
// 					{
// 						title: '批量重置密码',
// 						path: '',
// 						permission: SP33005,
// 						itemType: 99,
// 						sort: 5,
// 						childPermission: []
// 					},
// 					{
// 						title: '编辑',
// 						path: '',
// 						permission: SP33006,
// 						itemType: 99,
// 						sort: 6,
// 						childPermission: []
// 					},
// 					{
// 						title: '删除',
// 						path: '',
// 						permission: SP33007,
// 						itemType: 99,
// 						sort: 7,
// 						childPermission: []
// 					},
// 					{
// 						title: '重置密码',
// 						path: '',
// 						permission: SP33008,
// 						itemType: 99,
// 						sort: 8,
// 						childPermission: []
// 					}
// 				]
// 			}
// 		]
// 	},
// 	{
// 		title: '资源管理',
// 		path: '/workbench/teachingManagement',
// 		itemType: 1,
// 		sort: 4,
// 		permission: SP4000,
// 		childPermission: [
// 			{
// 				title: '查看',
// 				path: '',
// 				permission: SP40004,
// 				itemType: 99,
// 				sort: 4,
// 				childPermission: []
// 			}
// 		]
// 	},
// 	{
// 		title: '题库管理',
// 		path: '/workbench/abilityList',
// 		itemType: 1,
// 		sort: 5,
// 		permission: SP5000,
// 		childPermission: [
// 			{
// 				title: '题库列表',
// 				path: '/workbench/abilityList',
// 				itemType: 2,
// 				sort: 1,
// 				permission: SP5100,
// 				childPermission: [
// 					{
// 						title: '查看',
// 						path: '',
// 						permission: SP5100_yy_3,
// 						itemType: 99,
// 						sort: 3,
// 						childPermission: []
// 					}
// 				]
// 			}
// 		]
// 	},
// 	{
// 		title: '谱例管理',
// 		path: '/workbench/example_Manage',
// 		itemType: 1,
// 		sort: 6,
// 		permission: SP6000,
// 		childPermission: [
// 			{
// 				title: '查看',
// 				path: '',
// 				permission: SP60005,
// 				itemType: 99,
// 				sort: 5,
// 				childPermission: []
// 			}
// 		]
// 	},
// 	{
// 		title: '权益管理',
// 		path: '/workbench/exam_activity',
// 		itemType: 1,
// 		sort: 7,
// 		permission: SP7000,
// 		childPermission: []
// 	}
// ]

// export const defaultSPRouter = {
// 	label: 'title',
// 	children: 'childPermission'
// }
